module.exports = ".obs-span {\n  font-size: 0.6em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/billing-control/billing-control.component.scss
// module id = ./src/app/billing-control/billing-control/billing-control.component.scss
// module chunks = main